import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="px-4 md:px-8 pt-14 pb-8">
        <div className="max-w-content mx-auto grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-6">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-accent-500 flex items-center justify-center">
                <i className="ri-vidicon-2-line text-primary-950 text-lg" />
              </span>
              <span className="font-heading font-semibold text-lg text-background-50">
                继母的诱惑
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200/80 max-w-md">
              一个专注《继母的诱惑》的影视内容站。我们整理剧集全剧情、角色关系与幕后资讯，帮助每一位观众更深入地读懂这部经典家庭剧。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-900 text-background-200 cursor-pointer hover:text-accent-400">
                <i className="ri-weibo-line text-lg" />
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-900 text-background-200 cursor-pointer hover:text-accent-400">
                <i className="ri-wechat-line text-lg" />
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-900 text-background-200 cursor-pointer hover:text-accent-400">
                <i className="ri-youtube-line text-lg" />
              </span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">
              <Link to="/category/episodes" className="cursor-pointer">内容频道</Link>
            </h4>
            <ul className="space-y-2.5 text-sm text-background-200/80">
              <li>
                <Link to="/category/episodes" className="hover:text-accent-400 cursor-pointer">剧集剧情</Link>
              </li>
              <li>
                <Link to="/category/characters" className="hover:text-accent-400 cursor-pointer">角色分析</Link>
              </li>
              <li>
                <Link to="/category/news" className="hover:text-accent-400 cursor-pointer">影视资讯</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">
              <Link to="/about" className="cursor-pointer">关于本站</Link>
            </h4>
            <ul className="space-y-2.5 text-sm text-background-200/80">
              <li>
                <Link to="/about" className="hover:text-accent-400 cursor-pointer">网站定位</Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-accent-400 cursor-pointer">内容范围</Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-accent-400 cursor-pointer">联系反馈</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="max-w-content mx-auto mt-12 pt-6 border-t border-primary-800/60 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-300/70">
          <p>© 2026 继母的诱惑 影视内容站 · 本站内容均为演示数据，仅供浏览参考</p>
          <p>不提供播放、下载及任何形式的付费服务</p>
        </div>
      </div>
    </footer>
  );
}